import { formatLocaleCurrency, formatLocaleDate } from "@/utils/formatUtils";
import { Descriptions } from "antd";
import { useTranslation } from "react-i18next";
import { InsuranceType } from "../../../../enums";
import { Insurance } from "../../../../types";

type Props = {
  insurance: Insurance;
};

export const AdditionalContractInsuranceData = ({ insurance }: Props) => {
  const { t } = useTranslation();

  const isLifeInsurance = insurance.type === InsuranceType.LIFE;

  return (
    <Descriptions
      column={4}
      bordered
      size="small"
      layout="vertical"
      className="margin-bottom-small"
      items={[
        {
          label: t(
            isLifeInsurance
              ? "contract.attrs.insurances.contractEntryDateLife"
              : "contract.attrs.insurances.contractEntryDate",
          ),
          children: formatLocaleDate(insurance.contractEntryDate),
        },
        {
          label: t(
            isLifeInsurance
              ? "contract.attrs.insurances.contractWithdrawalDateLife"
              : "contract.attrs.insurances.contractWithdrawalDate",
          ),
          children: insurance.contractWithdrawalDate ? formatLocaleDate(insurance.contractWithdrawalDate) : undefined,
        },
        {
          label: t("contract.attrs.insurances.annualPremium"),
          children: formatLocaleCurrency(insurance.annualPremium),
        },
        {
          label: t("contract.attrs.insurances.partialPremium"),
          children: formatLocaleCurrency(insurance.partialPremium),
        },
      ]}
    />
  );
};
